mutation deleteCompanyWithDelay($id: ID!) {
  deleteCompanyWithDelay(id: $id)
}
